module.exports = __webpack_public_path__ + "img/in-the-mark@3x.ee2723eb.png";